import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { canAccessLab, type Role } from '@/types/navigation';

/** Direct /lab URLs use the same predicate as the navigation registry:
 * admin/manager always, traders only with a resolved `labAccess` level.
 * Revocation rerenders this guard and unmounts the framed lab at once. */
export function LabRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const labAccess = useAuthStore((s) => s.user?.labAccess ?? null);
  return canAccessLab(role, labAccess) ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
